const features = [
  {
    id: 1,
    icon: 'ri-scroll-to-bottom-line',
    title: '下拉式阅读',
    desc: '流畅的纵向滚动体验，像刷社交媒体一样轻松看漫画，适合快速浏览长篇连载，单手操作无压力。',
    highlight: '最受欢迎',
    color: 'primary',
  },
  {
    id: 2,
    icon: 'ri-window-line',
    title: '弹窗阅读',
    desc: '智能分格弹窗模式，自动识别漫画分镜，逐格弹出阅读，聚焦每一个精彩画面，沉浸感十足。',
    highlight: '沉浸体验',
    color: 'accent',
  },
  {
    id: 3,
    icon: 'ri-book-open-line',
    title: '翻页阅读',
    desc: '仿真翻页动画效果，还原纸质漫画的阅读仪式感，左右翻页自然顺手，适合传统漫画阅读习惯。',
    highlight: '经典还原',
    color: 'secondary',
  },
  {
    id: 4,
    icon: 'ri-hd-line',
    title: '高清显示',
    desc: '智能画质增强引擎，自动优化漫画线条和色彩，在任意设备上都能呈现最清晰锐利的画面效果。',
    highlight: '画质保障',
    color: 'primary',
  },
];

const colorMap: Record<string, { bg: string; text: string; iconBg: string; iconText: string }> = {
  primary: {
    bg: 'bg-primary-50 hover:bg-primary-100/80',
    text: 'text-primary-700',
    iconBg: 'bg-primary-100',
    iconText: 'text-primary-600',
  },
  accent: {
    bg: 'bg-accent-50 hover:bg-accent-100/80',
    text: 'text-accent-700',
    iconBg: 'bg-accent-100',
    iconText: 'text-accent-600',
  },
  secondary: {
    bg: 'bg-secondary-50 hover:bg-secondary-100/80',
    text: 'text-secondary-700',
    iconBg: 'bg-secondary-100',
    iconText: 'text-secondary-600',
  },
};

export default function FeaturesSection() {
  return (
    <section id="features" className="w-full py-16 md:py-22 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950">
            核心功能
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500">
            三种阅读模式，一种极致体验
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {features.map((feature) => {
            const c = colorMap[feature.color];
            return (
              <div
                key={feature.id}
                className={`${c.bg} rounded-xl p-6 border border-background-200/60 transition-colors cursor-pointer`}
              >
                <div className={`w-12 h-12 rounded-xl ${c.iconBg} flex items-center justify-center`}>
                  <i className={`${feature.icon} text-xl ${c.iconText}`}></i>
                </div>
                <h3 className="font-heading text-lg text-foreground-900 mt-4">
                  {feature.title}
                </h3>
                <p className="mt-2 text-sm text-foreground-600 leading-relaxed">
                  {feature.desc}
                </p>
                <span className={`inline-block mt-3 px-2.5 py-1 rounded-md text-xs font-bold ${c.iconBg} ${c.text}`}>
                  {feature.highlight}
                </span>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}